// Central shared configuration for supported legal pages.
// Keep this file framework-agnostic (no Angular/Nest imports) so it can be used by both server and client code.
export interface LegalPageConfigEntry {
  endpoint: string;
  responseKey: string;
}

export const LEGAL_PAGES_CONFIG: Record<string, LegalPageConfigEntry> = {
  'terms-of-service': { endpoint: 'tos-page', responseKey: 'termsOfService' },
  'data-protection': { endpoint: 'data-protection-page', responseKey: 'dataProtection' },
  imprint: { endpoint: 'imprint-page', responseKey: 'imprint' },
  'terms-of-use': { endpoint: 'terms-of-use-page', responseKey: 'termsOfUse' },
};

export const LEGAL_PAGES_SLUGS: string[] = Object.keys(LEGAL_PAGES_CONFIG);
